module.exports = function (msg, img) {
  var html = "\n    <div class=\"game-acknowledge-overlay\">\n      <div class=\"game-acknowledge-menu\">\n      </div>\n    </div>\n  ";
  return html;
};